(function () {
    'use strict';

    angular.module('edit')
        .service('editConfigService', editConfigService);

    editConfigService.$inject = ['serviceBase', 'arcgisBase', 'gazetteerUrl'];
    function editConfigService(serviceBase, arcgisBase, gazetteerUrl) {
        return {
            SaveObject: serviceBase + '/road-monitoring/save',
            UpdateStatus: serviceBase + '/road-monitoring/on-read/',
            JsonTransformCoords: arcgisBase + '/Utilities/Geometry/GeometryServer/project',
            JsonResolveRoad: arcgisBase + '/LakisKelioInfo/MapServer/exts/LakisKelioInfoSOE/kelioInfoByXY?x=',
            JsonResolveCoords: arcgisBase + '/LakisKelioInfo/MapServer/exts/LakisKelioInfoSOE/kelioInfoByKm?kelionr=',
            DeleteObject: serviceBase + '/road-monitoring/delete/',
            GetAddress: gazetteerUrl + '?skip=stop&limit=50&x=',
            changeStatus: serviceBase + '/road-monitoring/change-status',
            getHistory: serviceBase + '/road-monitoring/get-history',
            getObjectById: serviceBase + '/road-monitoring/get-object/',
            roadDivisions: serviceBase + '/road/divisions',
            roadSearch: serviceBase + '/road/search?p=',
            statusMap: {
                DATM: { DISP: false, DNAU: false, DATM: false, DSPR: false, DLAP: true },
                DISP: { DISP: false, DNAU: true, DATM: false, DSPR: false, DLAP: true },
                DNAU: { DISP: true, DNAU: false, DATM: true, DSPR: true, DLAP: true },
                DPER: { DISP: true, DNAU: false, DATM: true, DSPR: true, DLAP: true },
                DSPR: { DISP: true, DNAU: false, DATM: true, DSPR: false, DLAP: true },
                DLAP: { DISP: true, DNAU: true, DATM: true, DSPR: true, DLAP: false }
            },
            defaultStatusLowValue: 'DNAU',
            maxDistance: 150
        };
    }
})();
